 <template>
  <div
    :class="[
      'sevenPage',
      pageSevenAction ? 'animated pageFadeIn' : 'pageFadeOut',
    ]"
  >
    <div
      :class="[
        'sevenIconPng',
        sevenTitShow ? 'imgAnimated imgFadeIn' : 'bgGray',
      ]"
    ></div>
    <div :class="['titHeader', 'sevenAnimated']" v-if="sevenTitShow">
      实施全省林长制评估，<br />助力林长制改革
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <p class="textMian animated delay fadeIn" v-if="sevenTitShow">
        安徽省林长制实施情况第三方评估工作自2018年开始，已开展三年，我院连续两年承接评估工作。客观评价了全省林长制实施成效，总结了经验，分析了问题，并提出了合理化意见建议，得到省局的肯定和认同。
      </p>
    </div>

    <div class="bwBox" v-if="sevenBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianSeven.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', sevenTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "sevenPage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      pageSevenAction: false,
      sevenTitShow: false,
      sevenBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/sevenK001.jpg",
        },
        {
          imgUrl: "img/dhShare/sevenK002.jpg",
        },
        {
          imgUrl: "img/dhShare/sevenK003.jpg",
        },
        {
          imgUrl: "img/dhShare/sevenK004.jpg",
        },
        {
          imgUrl: "img/dhShare/sevenK005.jpg",
        },
        {
          imgUrl: "img/dhShare/sevenK006.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageSevenAction = true;
    },
    changeHue() {
      this.sevenBtnShow = false;
      this.sevenTitShow = true;
    },
    seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "6") {
        this.pageSevenAction = true;
      } else {
        this.pageSevenAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.sevenPage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideSeven.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .sevenIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/sevenIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .titHeader {
    top: 60%;
    border: 1px solid #17c7af;
    color: #17c7af;
    .circle {
      border: 1px solid #17c7af;
    }
  }
  .titBox {
    position: absolute;
    top: 20px;
    right: 35px;

    .textMian {
      width: 240px;
      position: absolute;
      top: 0;
      left: 0;
      font-size: 12px;
      color: #17c7af;
      text-align: justify;
      opacity: 0;
      z-index: 999;
    }
  }
  // .tit {
  //   position: absolute;
  //   width: 300px;
  //   left: 10px;
  //   top: 10px;
  //   font-size: 16px;
  //   color: #a2561a;
  //   font-weight: 600;
  // }
  .sevenAnimated {
    animation: bounceInDown 2s forwards linear;
    /* Safari 和 Chrome */
  }

  .imgMainBox {
    display: none;
    position: absolute;
    bottom: 25px;
    left: 0;
    // -webkit-transform: rotate(90deg);
    // transform: rotate(90deg);
    z-index: 999;
    width: 100%;

    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>